export default __webpack_public_path__ + "static/media/nflChime.1aa68c44.mp3";